export default __webpack_public_path__ + "static/media/component_joystick_v2.d5fc249d.png";